import React from 'react';
import { connect } from 'react-redux';

import { builderSetShouldEditParties } from '~/actions/builder';
import { useIntl } from 'react-intl';
import { getPartyIds } from '~/reducers/workflow';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Link from '~/ui/components/Link/Link';
import PageLayout from '~/ui/components/PageLayout/PageLayout';

import EmptySectionItem from '../EmptySectionItem';
import Party from './Party';

function PartySignerFieldSection({
  // connected
  disabled,
  partyIds,
  builderSetShouldEditParties,
}) {
  const intl = useIntl();
  const Content =
    partyIds.length === 0 ? (
      <EmptySectionItem
        message={intl.formatMessage({
          id: 'WorkflowBuilderPage.Sidebar.PartySignerFieldSection.emptyState',
          defaultMessage: 'No parties yet',
          description:
            'Message shown in the parties section of the sidebar when no parties have been added yet',
        })}
      />
    ) : (
      <FlexLayout flexDirection="column" space={3}>
        {partyIds.map((partyId) => (
          <Party key={partyId} partyId={partyId} />
        ))}
      </FlexLayout>
    );

  return (
    <PageLayout.SidebarSection
      headerRightContent={
        disabled ? null : (
          <Link
            variant="xs-dense-bold"
            onClick={() => builderSetShouldEditParties(true)}
          >
            {intl.formatMessage({
              id: 'workflowBuilderPage.sidebar.partySignerFieldSection.edit',
              defaultMessage: 'Edit',
              description:
                'Button label to edit parties in the workflow builder sidebar',
            })}
          </Link>
        )
      }
      title={intl.formatMessage({
        id: 'PartySignerFieldSection.partiesSectionTitle',
        defaultMessage: 'Parties',
        description: 'Title for parties section',
      })}
    >
      {Content}
    </PageLayout.SidebarSection>
  );
}

function mapStateToProps({ builder, workflow }) {
  return {
    disabled: !builder.shouldEnableAllComponents,
    partyIds: getPartyIds(workflow),
  };
}

export default connect(mapStateToProps, { builderSetShouldEditParties })(
  PartySignerFieldSection,
);
